/**
 * Precificacao: faixas de taxa, agravos e descontos.
 *
 * Reexportado por `../resources.ts`. Ver docs/FRONTEND.md, secao 3.
 */

import type { Money } from './comum';

import { api } from '../client';

export interface RateBand {
  id: string;
  product_id: string;
  modality_id: string;
  min_amount: Money;
  max_amount: Money | null;
  min_rate_bps: number;
  max_rate_bps: number;
  base_rate_bps: number;
  effective_from: string;
  status: 'ativa' | 'inativa';
  notes: string;
  created_label: string;
  created_at: string;
}

export interface RateBandInput {
  product_id?: string;
  modality_id?: string;
  min_amount?: Money;
  max_amount?: Money | null;
  min_rate_bps: number;
  max_rate_bps: number;
  base_rate_bps: number;
  effective_from?: string;
  status?: 'ativa' | 'inativa';
  notes?: string;
}

export interface RateAdjustment {
  id: string;
  kind: 'agravo' | 'desconto';
  label: string;
  description: string;
  delta_bps: number;
  signed_bps: number;
  status: 'ativo' | 'inativo';
  created_label: string;
  created_at: string;
}

export interface RateAdjustmentInput {
  kind: 'agravo' | 'desconto';
  label: string;
  description?: string;
  delta_bps: number;
  status?: 'ativo' | 'inativo';
}

export interface RateQuote {
  band: RateBand;
  adjustments: RateAdjustment[];
  rate_bps: number;
}

export const pricing = {
  bands: (modalityId: string | undefined, signal?: AbortSignal) =>
    api.get<RateBand[]>(
      `/api/v1/rate-bands${modalityId ? `?modality_id=${modalityId}` : ''}`,
      signal,
    ),
  createBand: (input: RateBandInput) => api.post<RateBand>('/api/v1/rate-bands', input),
  updateBand: (id: string, input: RateBandInput) =>
    api.patch<RateBand>(`/api/v1/rate-bands/${id}`, input),
  suggestion: (modalityId: string, amount: number, signal?: AbortSignal) =>
    api.get<RateQuote>(
      `/api/v1/rate-bands/suggestion?modality_id=${modalityId}&amount=${amount}`,
      signal,
    ),
  adjustments: (signal?: AbortSignal) =>
    api.get<RateAdjustment[]>('/api/v1/rate-adjustments', signal),
  createAdjustment: (input: RateAdjustmentInput) =>
    api.post<RateAdjustment>('/api/v1/rate-adjustments', input),
  updateAdjustment: (id: string, input: RateAdjustmentInput) =>
    api.patch<RateAdjustment>(`/api/v1/rate-adjustments/${id}`, input),
};
